"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorators = void 0;
var addDecorator_1 = require("./preset/addDecorator");
Object.defineProperty(exports, "decorators", { enumerable: true, get: function () { return addDecorator_1.decorators; } });
//# sourceMappingURL=index.js.map